import { URL_IMG_DOMAIN } from '@/common/resources/const'
import { getDomainWithPrefix } from '@/common/utils/common'

const DEFAULT_IMAGE_QUALITY = 80
const DEFAULT_IMAGE_OPTION = 20
const CIRCLE_IMAGE_MAX_WIDTH = 330
const DEFAULT_IMAGE_RATIO = 2
export const widthHeightQuality = (width, height, quality, option) => {
  return `${width}_${height}_${option}_${quality}`
}

export const removeOrigin = (url) => {
  return url
    .replace('dev-', '')
    .replace('qa-', '')
    .replace('img.wavve.com', '')
    .replace('img.pooq.co.kr', '')
    .replace('image.wavve.com', '')
    .replace('image.cdn.wavve.com', '')
    .replace('https://', '')
    .replace('http://', '')
}

export const addImageDomain = (imagePath) => {
  return `${URL_IMG_DOMAIN}/${imagePath}`
}

export const addPrefixThumbnail = (url) => {
  return `https://${url}`
}

export const resize = (
  imagePath,
  { width, height, quality, option, envPrefix },
) => {
  imagePath = imagePath[0] === '/' ? imagePath.substring(1) : `${imagePath}`
  const combinationOfImageOption = widthHeightQuality(
    width,
    height,
    quality,
    option,
  )
  return getDomainWithPrefix(
    addPrefixThumbnail(
      addImageDomain(`v1/thumbnails/${combinationOfImageOption}/${imagePath}`),
    ),
    envPrefix,
  )
}

export const resizeThumbnail = (
  url = '',
  {
    width = 0,
    height = 0,
    quality = DEFAULT_IMAGE_QUALITY,
    option = DEFAULT_IMAGE_OPTION,
    isCircle = false,
    ratio = DEFAULT_IMAGE_RATIO,
    envPrefix,
  },
) => {
  if (url === '') return url
  const imagePath = removeOrigin(url)
  return resize(imagePath, {
    width: isCircle ? CIRCLE_IMAGE_MAX_WIDTH : width * ratio,
    height: isCircle ? 0 : height * ratio,
    quality,
    option,
    envPrefix,
  })
}
